import { requestData } from "./utils";
export default class InboxMessagesModule {
  send(data) {
    data.enterprises =
      data.enterprise_id === "all"
        ? data.enterprises.map((e) => e.enterprise_id)
        : [data.enterprise_id];
    return requestData("POST", "/inbox-message", data);
  }
  getInboxMessages(data, abortSignal) {
    return requestData("GET", "/inbox-messages", data, undefined, abortSignal);
  }
  markInboxMessageAsRead(inbox_message_id) {
    return requestData("POST", `/inbox-message-mark-as-read/${inbox_message_id}`);
  }
}